import type { Prismic } from '@landsbankinn/prismic';
import { Embed, getRichTextEmbedHtml } from '@landsbankinn/prismic';
import { Row, Column, Container, theme } from '@landsbankinn/ui';
import isEmpty from 'lodash.isempty';
import React from 'react';

interface IProps {
  embed: Prismic.RichText;
  embed2?: Prismic.RichText;
  height: number;
}

function getEmbedHtml(embed?: Prismic.RichText) {
  if (!embed || isEmpty(embed)) {
    return null;
  }

  return getRichTextEmbedHtml(embed);
}

export const EmbedContainer = ({ embed, embed2, height }: IProps) => {
  const html1 = getEmbedHtml(embed);
  const html2 = getEmbedHtml(embed2);
  // set height to 9/16 if no height

  const correctHeight = height ? height / theme.pageWidth : 9 / 16;
  if (html2) {
    return (
      <Container>
        <Row>
          <Column width={1 / 2}>
            <Embed type="inline" html={html1} ar={correctHeight} />
          </Column>
          <Column width={1 / 2}>
            <Embed type="inline" html={html2} ar={correctHeight} />
          </Column>
        </Row>
      </Container>
    );
  }

  if (!html1) {
    return null;
  }

  return <Embed html={html1} ar={correctHeight} />;
};
